import styled from 'styled-components';

export const MainVideoFrame = styled.div`
  position: absolute;
  inset: 0;
  min-width: 0;
  min-height: 0;
  overflow: hidden;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ProfileMainCard = styled.div`
  min-height: 0;
  border-radius: 0;
`;

export const ProfileMainName = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

export const ProfileMainSubtext = styled.div`
  font-size: 13px;
  opacity: 0.85;
`;
